import { Box } from "@mui/material";

export const Logo = (props) => {
  const {
    src = `${process.env.PUBLIC_URL}/static/sites/${process.env.REACT_APP_SITE}/images/logo.png`,
  } = props;

  return (
    <Box
      component="img"
      sx={{
        width: "auto",
        height: "100%",
        objectFit: "contain",
      }}
      src={src}
      alt="로고"
    />
  );
};
